module.exports = __webpack_public_path__ + "static/media/call.3da14ad6.png";